module.exports = __webpack_public_path__ + "static/img/kexinjiaren.f4a6cdc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/kexinjiaren.png
// module id = 3OO2
// module chunks = 1